import { useEffect, useMemo, useState, useCallback } from 'react'
import { cleanEmptyField, getCountryTimezoneUtc, numberFormat } from '../../../helper'
import { webSocketWorkerEvent } from '../../../services'
import { DIRECTION } from '../../../utils/constants'

const useAgGridActivityBlotter = ({
  priceRatesNormalize,
  filters,
  setFilters,
  skeltonLoader,
  widgets
}) => {
  const [activityBlotterResponse, setActivityBlotterResponse] = useState({
    activity_blotter_clients: [],
    activity_blotter_market_makers: []
  })

  const addDirectionToActivityBlotter = (activity_blotter, direction) =>
    activity_blotter.map(d => ({ ...d, direction }))

  useEffect(() => {
    const handelMessage = message => {
      if (
        message.data.type === 'get_activity_blotter' &&
        message.data.status === 'ok' &&
        message.data.data
      ) {
        message.data.data.activity_blotter_clients = addDirectionToActivityBlotter(
          message.data.data.activity_blotter_clients,
          DIRECTION.CLIENT
        )
        message.data.data.activity_blotter_market_makers = addDirectionToActivityBlotter(
          message.data.data.activity_blotter_market_makers,
          DIRECTION.MARKET_MAKER
        )
        setActivityBlotterResponse(message.data.data)
      }
      if (
        message.data.type === 'get_user_view' &&
        message.data.status === 'ok' &&
        message.data.data.view_was_changed === true &&
        widgets.includes('Activity Blotter')
      ) {
        webSocketWorkerEvent.sendEvent({
          type: 'get_activity_blotter',
          data: {
            country_timezone_utc: getCountryTimezoneUtc()
          }
        })
      }
    }
    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [priceRatesNormalize, widgets])

  const defaultColDef = useMemo(
    () => ({
      fontSize: '14px',
      resizable: true,
      wrapText: false,
      flex: 1,
      autoHeight: false
    }),
    []
  )

  const onRowClicked = useCallback(
    params => {
      const copyFilters = JSON.parse(JSON.stringify(filters))
      copyFilters.trading_account_shortname = params.data.account
      copyFilters.country_timezone_utc = getCountryTimezoneUtc()
      copyFilters.trading_account_direction = params.data.direction
      delete copyFilters.trade_date_start_look_for
      delete copyFilters.trade_date_end_look_for
      cleanEmptyField(copyFilters)
      setFilters(copyFilters)
      skeltonLoader()
      webSocketWorkerEvent.sendEvent({
        type: 'get_trade_blotter',
        data: copyFilters
      })
    },
    [filters]
  )

  const columnsDefs = useMemo(
    () => [
      {
        headerName: 'Account',
        field: 'account'
      },
      {
        headerName: 'Trades',
        field: 'trades'
      },
      {
        headerName: 'Volume (mm)',
        field: 'quantity',
        valueFormatter: params => {
          return `${numberFormat(params.data.quantity / 10 ** 6, 5)}`
        }
      },
      {
        headerName: 'P&L (USD)',
        field: 'pnl',
        valueFormatter: params => {
          return `${numberFormat(params.data.pnl)}`
        }
      },
      {
        headerName: 'Direction',
        field: 'direction',
        hide: true
      }
    ],
    []
  )

  return { columnsDefs, defaultColDef, activityBlotterResponse, onRowClicked }
}

export default useAgGridActivityBlotter
